import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { AdminEffects } from "./admin.effects";
import { adminReducer } from "./admin.reducer";

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature("admin", adminReducer),
        EffectsModule.forFeature([AdminEffects]),
    ],
    providers: []
})
export class AdminStateModule { }
